import { action, observable } from 'mobx';
import { BaseStore } from '~web/store/base/base-store';

interface HistoryBlockDialogParameters {
  title: string;
  noLabel: string;
  yesLabel: string;
}

export class HistoryBlockStore extends BaseStore {
  @observable
  dialogShown: boolean;
  title: string;
  noLabel: string;
  yesLabel: string;
  onNo: () => void;
  onYes: () => void;

  constructor() {
    super();
    this.dialogShown = false;
  }

  @action
  showDialog(parametersString: string, callback: (result: boolean) => void): void {
    const parameters: HistoryBlockDialogParameters = JSON.parse(parametersString);
    this.title = parameters.title;
    this.noLabel = parameters.noLabel;
    this.yesLabel = parameters.yesLabel;
    this.onNo = (): void => {
      callback(false);
      this.hideDialog();
    };
    this.onYes = (): void => {
      callback(true);
      this.hideDialog();
    };
    this.dialogShown = true;
  }

  @action
  hideDialog(): void {
    this.title = undefined;
    this.noLabel = undefined;
    this.yesLabel = undefined;
    this.onNo = undefined;
    this.onYes = undefined;
    this.dialogShown = false;
  }
}

// TODO tests
export const getHistoryBlockString = (
  title: string,
  noLabel?: string,
  yesLabel?: string,
): string => {
  const parameters: HistoryBlockDialogParameters = {
    title: title,
    noLabel: noLabel,
    yesLabel: yesLabel,
  };
  return JSON.stringify(parameters);
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/store/history-block-store.ts